import React, { useState } from "react";
import { toast } from "sonner";
import { Download, Loader2 } from "lucide-react";
import { API_BASE } from "../lib/api";
import { Button } from "./ui/button";

export default function OptInExport() {
  const [busy, setBusy] = useState(false);
  const download = async () => {
    setBusy(true);
    try {
      const r = await fetch(`${API_BASE}/admin/marketing-optins.csv`, { credentials: "include" });
      if (!r.ok) throw new Error("Could not download the opt-in list.");
      const name = (r.headers.get("content-disposition") || "").match(/filename="([^"]+)"/)?.[1] || "greenflow-marketing-optins.csv";
      const a = document.createElement("a");
      a.href = URL.createObjectURL(await r.blob());
      a.download = name;
      a.click();
      URL.revokeObjectURL(a.href);
    } catch (e) {
      toast.error(e.message);
    } finally {
      setBusy(false);
    }
  };
  return (
    <Button data-testid="export-optins-button" onClick={download} disabled={busy} variant="outline" className="rounded-full border-emerald-300 bg-white text-emerald-800 hover:bg-emerald-50 hover:text-emerald-900 disabled:opacity-70">
      {busy ? <Loader2 size={14} className="mr-1.5 animate-spin" /> : <Download size={14} className="mr-1.5" />} Export Opt-In List (CSV)
    </Button>
  );
}
